import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { getCurrentLangKey, getLangs, getUrlForLang } from 'ptz-i18n';
import { IntlProvider, FormattedMessage } from 'react-intl';
import 'intl';

import Header from '../components/Header';
import Footer from '../components/Footer';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'styles/global.scss';
import favicon from './favicon.ico'

const Layout = (props) => {

  const { children, location, data, i18nMessages } = props;

  const url = location.pathname;
  const { langs, defaultLangKey } = data.site.siteMetadata.languages;
  const langKey = getCurrentLangKey(langs, defaultLangKey, url);
  const homeLink = `/${langKey}/`;
  const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url));

  const { menu } = data.site.siteMetadata;

  return (
    <IntlProvider
      locale={langKey}
      messages={i18nMessages}
      textComponent={React.Fragment}
    >
      <div>
        <Helmet>
          <title> {i18nMessages.title} </title>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Cinzel|Varela+Round" />
          <link rel="shortcut icon" type="image/ico" href={`${favicon}`} />
          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.2.0/css/all.css" integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ" crossorigin="anonymous"/>
          <meta name="theme-color" content="#30638E" />
          <meta name="description" content="Scichess, intelligent solution to learning chess" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        </Helmet>


        <Header
          langs={langsMenu}
          menu={menu}
        />

        {children()}

        <Footer
          menu={menu}
        />

      </div>
    </IntlProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout;


// WEBPACK FOOTER //
// ./src/layouts/_layout.js